import { SHARE_DOMAIN_LABEL } from "../config/lumacofono";
import { warn } from "./log";
import { renderResultImage } from "./resultImage";
import { buildChallengeUrl } from "./challenge";

const FILE_NAME = "costruisci-la-tua-ciurma-lumacofono.png";

export const buildResultFile = async (data) =>
  new File([await renderResultImage(data)], FILE_NAME, { type: "image/png" });

export const buildShareText = (island, crewName, destinationIndex) =>
  `🏴‍☠️ ${crewName ? `${crewName}: la mia ciurma` : "La mia ciurma"} è arrivata fino a ${island}.\nRiesci a battermi?\n${buildChallengeUrl(destinationIndex, crewName)}\n${SHARE_DOMAIN_LABEL}`;

const downloadFile = (file) => {
  const url = URL.createObjectURL(file);
  const a = document.createElement("a");
  a.href = url;
  a.download = file.name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
};

const copyText = async (text) => {
  if (navigator.clipboard?.writeText) return navigator.clipboard.writeText(text);
  const ta = document.createElement("textarea");
  ta.value = text;
  document.body.appendChild(ta);
  ta.select();
  document.execCommand("copy");
  ta.remove();
};

// Returns true when the native share sheet handled it (or the user dismissed it).
const tryNativeShare = async (file, text) => {
  if (!file || !navigator.canShare?.({ files: [file] })) return false;
  try {
    await navigator.share({ files: [file], text });
    return true;
  } catch (e) {
    return e.name === "AbortError";
  }
};

// Returns the fallback status to show ("image" | "text"), or null if shared natively.
export const shareResult = async (file, text) => {
  if (await tryNativeShare(file, text)) return null;
  if (file) downloadFile(file);
  await copyText(text).catch((e) => warn("Copia negli appunti non riuscita", e));
  return file ? "image" : "text";
};
